import React from 'react';
import CheckStepStatus from './checkStepStatus';
import { useTranslate } from '@tolgee/react';
import UserInfoTimelineCard from './userInfoTimelineCard';
import {APPROVAL_STEP_RULE_ALL, APPROVAL_STEP_RULE_ALL_TEXT, APPROVAL_STEP_RULE_ANY_TEXT} from "../../constants";
import {buildApprovalStepRuleLabel} from "../../../utils";

interface StatusHeaderProps {
  status: 'approved' | 'rejected' | 'empty';
  title: string;
  dateTime?: any;
  rule?: number;
  group?: any;
  users?: any[];
}
const StatusHeaderTag: React.FC<StatusHeaderProps> = ({
  status,
  title,
  dateTime,
  rule,
  group,
  users
}) => {
  const { t } = useTranslate();

  return (
    <div className="d-flex gap-2">
      <div>
        <CheckStepStatus status={status} withBorder />
      </div>

      <div className=" d-flex flex-column timeline-content mt-1 mb-0 justify-content-center">
        <div className="fs-5 fw-semibold mb-0">{title}</div>

        {dateTime && <div className="text-muted me-2 fs-7">{dateTime}</div>}
        {group && (
          <div className="text-muted me-2 fs-7">
            {t('lomavisPostApproval.statusHeader.groupName')}: {group?.name}
          </div>
        )}

        {rule && (
          <div className="text-muted me-2 fs-7">
            {t('lomavisPostApproval.statusHeader.rule')}:{' '}
            {rule == APPROVAL_STEP_RULE_ALL
              ? t(buildApprovalStepRuleLabel(APPROVAL_STEP_RULE_ALL_TEXT))
              : t(buildApprovalStepRuleLabel(APPROVAL_STEP_RULE_ANY_TEXT))}
          </div>
        )}

        {users?.length > 0 &&
          users?.map((user) => <UserInfoTimelineCard user={user} />)}
      </div>
    </div>
  );
};

export default StatusHeaderTag;
